// 2026-10-22 coder(lq): CLI 能力目录的枚举、默认值与「多行文本 <-> JSON 数组」转换集中在此，
// 页面只负责展示与提交；scenes/notFor 在库里是 JSON 数组字符串，接口原样透出。
export const KIND_OPTIONS = [
    { value: 'tool', label: '工具 tool' },
    { value: 'data', label: '数据 data' },
    { value: 'doc', label: '文档 doc' },
]
export const KIND_META = {
    tool: { text: '工具', color: 'blue' },
    data: { text: '数据', color: 'green' },
    doc: { text: '文档', color: 'purple' },
}
export const AUDIENCE_OPTIONS = [
    { value: 'all', label: '全员 all' },
    { value: 'tech', label: '技术 tech' },
]
export const AUDIENCE_META = {
    all: { text: '全员', color: 'default' },
    tech: { text: '技术', color: 'geekblue' },
}
export const STATUS_OPTIONS = [
    { value: 'available', label: '可用 available' },
    { value: 'beta', label: '内测 beta' },
    { value: 'deprecated', label: '已弃用 deprecated' },
]
export const STATUS_META = {
    available: { text: '可用', color: 'green' },
    beta: { text: '内测', color: 'orange' },
    deprecated: { text: '已弃用', color: 'red' },
}
export const ENTRY_TYPE_OPTIONS = [
    { value: 'cli', label: '命令行 cli' },
    { value: 'skill', label: 'Skill skill' },
    { value: 'web', label: '网页 web' },
    { value: 'api', label: '接口 api' },
]
export const ENTRY_TYPE_META = {
    cli: '命令行',
    skill: 'Skill',
    web: '网页',
    api: '接口',
}
export const ENABLED_OPTIONS = [
    { value: 1, label: '已启用' },
    { value: 0, label: '已停用' },
]
// 编码是表唯一键，也是 CLI 与文档引用条目的稳定标识，只允许字母数字开头，避免历史数据出现空格/中文。
export const CODE_PATTERN = /^[a-z0-9][a-z0-9_-]{0,63}$/i
export const NEW_ITEM = {
    code: '',
    name: '',
    kind: 'tool',
    summary: '',
    scenes: '',
    notFor: '',
    entryType: 'cli',
    entryValue: '',
    audience: 'all',
    owner: '',
    status: 'available',
    docTopic: '',
    sortOrder: 0,
    remark: '',
}
/**
 * 多行文本 -> JSON 数组字符串，供「适用场景」「不适用场景」保存。
 * 空行、纯空白行不进入数组；空文本保存为 "[]"，与表字段的 JSON 数组语义一致。
 */
export function linesToJsonArray(text) {
    const lines = String(text || '')
        .split(/\r?\n/)
        .map(line => line.trim())
        .filter(Boolean)
    return JSON.stringify(lines)
}
/**
 * JSON 数组字符串 -> 多行文本。历史数据可能不是合法 JSON 或不是数组，
 * 此时原样返回，避免编辑一次就把脏数据清空（契约要求容错）。
 */
export function jsonArrayToLines(value) {
    if (value === null || value === undefined || value === '') return ''
    if (Array.isArray(value)) return value.map(item => String(item)).join('\n')
    if (typeof value !== 'string') return String(value)
    try {
        const parsed = JSON.parse(value)
        if (Array.isArray(parsed)) return parsed.map(item => String(item)).join('\n')
    } catch (error) {
        // 解析失败按原样展示，保存时由管理员自行决定是否整理。
    }
    return value
}
/** 组装 /item/save 的 Item 请求体；enabled 由列表当前值透传，避免普通保存把停用条目重新启用。 */
export function buildItemPayload(values, { id, enabled } = {}) {
    const text = value => String(value === null || value === undefined ? '' : value).trim()
    const optional = value => text(value) || null
    const sortOrder = Number(values.sortOrder)
    const payload = {
        code: text(values.code),
        kind: values.kind,
        name: text(values.name),
        summary: optional(values.summary),
        scenes: linesToJsonArray(values.scenes),
        notFor: linesToJsonArray(values.notFor),
        entryType: values.entryType || null,
        entryValue: optional(values.entryValue),
        audience: values.audience,
        owner: optional(values.owner),
        status: values.status,
        docTopic: optional(values.docTopic),
        sortOrder: Number.isFinite(sortOrder) ? Math.trunc(sortOrder) : 0,
        enabled: Number(enabled) === 0 ? 0 : 1,
        remark: optional(values.remark),
    }
    if (id) payload.id = id
    return payload
}
/** 文档编辑器的字数统计：按字符数（含空白）+ 行数展示，不做富文本预览。 */
export function docWordCount(content) {
    return String(content || '').length
}
export function docLineCount(content) {
    const value = String(content || '')
    return value ? value.split(/\r?\n/).length : 0
}
